import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abc3cb60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "p-error"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "country-item" }
const _hoisted_5 = { class: "p-ml-2" }
const _hoisted_6 = { class: "p-ml-2 f-size-14" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times p-my-auto",
  style: {"fontsize":"2rem"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 3 }
const _hoisted_10 = {
  key: 0,
  class: "text-error"
}
const _hoisted_11 = {
  key: 1,
  class: "text-error"
}
const _hoisted_12 = {
  key: 2,
  class: "text-error"
}
const _hoisted_13 = {
  key: 3,
  class: "text-error"
}
const _hoisted_14 = {
  key: 4,
  class: "text-error"
}
const _hoisted_15 = {
  key: 5,
  class: "text-error"
}
const _hoisted_16 = {
  key: 6,
  class: "text-error"
}
const _hoisted_17 = {
  key: 7,
  class: "text-error"
}
const _hoisted_18 = {
  key: 8,
  class: "text-error"
}
const _hoisted_19 = {
  key: 9,
  class: "text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['select-custom', { error: _ctx.isValidate }])
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("br", _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_AutoComplete, {
      name: _ctx.name,
      modelValue: _ctx.modelValue,
      suggestions: _ctx.options,
      oninput: _ctx.oninput,
      onComplete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearchList($event))),
      onItemSelect: _ctx.onSelectItem,
      onInput: _cache[1] || (_cache[1] = (event) => _ctx.$emit('update:modelValue', event.target.value)),
      field: _ctx.field,
      placeholder: _ctx.placeholder,
      inputClass: ['btn-select', { error: _ctx.isValidate }],
      disabled: _ctx.isDisplay,
      autocomplete: 'new-evnet' + Math.floor(Date.now() / 1000)
    }, _createSlots({ _: 2 }, [
      (_ctx.isAddress)
        ? {
            name: "item",
            fn: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(slotProps.item.zipcode), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(slotProps.item.districtInfo.districtNameLocal) + ", " + _toDisplayString(slotProps.item.provinceInfo.provinceNameLocal) + ", " + _toDisplayString(slotProps.item.zipcode), 1)
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["name", "modelValue", "suggestions", "oninput", "onItemSelect", "field", "placeholder", "inputClass", "disabled", "autocomplete"]),
    (_ctx.isDisplay)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "clear-btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClearItem && _ctx.onClearItem(...args)))
        }, _hoisted_8))
      : _createCommentVNode("", true),
    (_ctx.v && _ctx.v.$error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.v.required && _ctx.v.required.$invalid == true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, " กรุณากรอกข้อมูลให้ครบถ้วน "))
            : (_ctx.v.minLength && _ctx.v.minLength.$invalid == true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createElementVNode("span", null, " กรุณากรอกอย่างน้อย " + _toDisplayString(_ctx.v.minLength.$params.min) + " อักษร ", 1)
                ]))
              : (_ctx.v.validateTotal && _ctx.v.validateTotal.$invalid == true)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "กรุณาระบุจำนวนเงินให้ถูกต้อง"))
                : (_ctx.v.email && _ctx.v.email.$invalid == true)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, "กรุณากรอกอีเมล (เช่น email@example.com)\","))
                  : (_ctx.v.integer && _ctx.v.integer.$invalid == true)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "กรุณากรอกตัวเลขเท่านั้น"))
                    : (_ctx.v.maxLength && _ctx.v.maxLength.$invalid == true)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "กรุณากรอกไม่เกิน " + _toDisplayString(_ctx.v.$params.maxLength.max) + " อักษร", 1))
                      : (_ctx.v.decimal && _ctx.v.decimal.$invalid == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, "กรุณากรอกตัวเลขเท่านั้น"))
                        : (_ctx.v.minValue && _ctx.v.minValue.$invalid == true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "กรุณากรอกตัวเลขเท่านั้น"))
                          : (_ctx.v.alpha && _ctx.v.alpha.$invalid == true)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "กรอกเฉพาะตัวอักษรเท่านั้น"))
                            : (_ctx.v.address && _ctx.v.address.$invalid == true)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, "กรุณากรอกข้อมูลที่อยู่ให้ถูกต้อง"))
                              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}